import { useState } from 'react';
import CtaPill from '../../../../../../common/_custom/CtaPill/CtaPill';
import { ctaPurpleRight } from '../../../../../../assets/hostedassets';
import type { MsmeDelayGraph } from '../../../../../../store/dashboard/compliancesBefe/types';
import { MSME_DELAY_BUTTON_LABEL } from './constants';
import MsmeDelayDrawer from './MsmeDelayDrawer';

/** "Delay Details" — hidden when the org has no stored MSME period. */
const MsmeDelayButton = ({ graphData }: { graphData: MsmeDelayGraph }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    if (!graphData?.plots?.[0]?.plotValues?.length) return null;
    return (
        <>
            <CtaPill size="small" label={MSME_DELAY_BUTTON_LABEL} icon={ctaPurpleRight} onClick={() => setIsDrawerOpen(true)} />
            {isDrawerOpen && <MsmeDelayDrawer graphData={graphData} onClose={() => setIsDrawerOpen(false)} />}
        </>
    );
};

export default MsmeDelayButton;
